<template>
		<div id="pageRoot">

			<p id="text01">
				Y Venancio saltaba. Saltaba cada vez más y más alto: del suelo hasta una silla, después del suelo hasta la mesa y por fin del suelo hasta el techo de la heladera.<br>
				<br>
				A Venancio le gustó eso de andar por los aires.<br>
				<br>
				Tanto le gustó que una mañana, sin esperar siquiera a que don Fito le dijera "¡Hop, Venancio!", se trepó de un solo salto al techo de la casa. ¡Quería ver la salida del sol desde ahí arriba!<br>
				<br>
				Don Fito estaba muy orgulloso de Venancio. A don Fito, Venancio le parecía un perro muy inteligente.<br>
				<br>
				—Te voy a enseñar a volar —le decía —¡Hop, Venancio! —decía con el dedo en alto, y lo mandaba de un brinco al techo. Después, sin que Venancio se diese cuenta, se iba en puntas de pie a la casa de doña Enriqueta, que vive justo enfrente, se subía a la terraza y le gritaba: —¡Acá, Venancio!<br>
				<br>
				¡Y Venancio saltaba del techo de don Fito a la terraza de doña Enriqueta! Era un salto verdaderamente extraordinario.<br>
				<br>
				Lo más difícil de todo fue enseñarle a dar media vuelta en el aire.
			</p>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<span class="footer-page footer-listen"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>

/* Y Venancio saltaba. Saltaba cada vez más y más alto: del suelo hasta una silla, después del suelo hasta la mesa y por fin del suelo hasta el techo de la heladera. A Venancio le gustó eso de andar por los aires. Tanto le gustó que una mañana, sin esperar siquiera a que don Fito le dijera "¡Hop, Venancio!", se trepó de un solo salto al techo de la casa. ¡Quería ver la salida del sol desde ahí arriba! Don Fito estaba muy orgulloso de Venancio. A don Fito, Venancio le parecía un perro muy inteligente. -Te voy a enseñar a volar- le decía - ¡Hop, Venancio! - decía con el dedo en alto, y lo mandaba de un brinco al techo. Después, sin que Venancio se diese cuenta, se iba en puntas de pie a la casa de doña Enriqueta, que vive justo enfrente, se subía a la terraza y le gritaba-: ¡Acá, Venancio! ¡Y Venancio saltaba del techo de don Fito a la terraza de doña Enriqueta! Era un salto verdaderamente extraordinario. Lo más difícil de todo fue enseñarle a dar media vuelta en el aire. */

#text01 
{
position: absolute;
left: 4.98%;
right: 4.98%;
top: 7.68%;
bottom: 13.28%;
margin: 0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 22px;
line-height: 27px;
color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p53-57/V16.mp4"]
    }
  }
}
</script>